import { LineItemModel } from './LineItem.model';
import { ModelContext } from './ModelContext';
import { cartV2 } from '@wix/ecom';

export class CartModel {
  public id: string;
  /**
   * @deprecated
   */
  public cartId?: string;
  public purchaseFlowId: string;
  public lineItems: LineItemModel[];
  public deliveryMethodCode?: string;
  public currency: string;
  public pricesIncludeTax?: boolean;

  constructor(model: CartModel) {
    this.id = model.id;
    this.cartId = model.cartId;
    this.purchaseFlowId = model.purchaseFlowId;
    this.lineItems = model.lineItems;
    this.deliveryMethodCode = model.deliveryMethodCode;
    this.currency = model.currency;
    this.pricesIncludeTax = model.pricesIncludeTax;
  }

  public static fromV2(cart: cartV2.Cart, modelContext: ModelContext) {
    return new CartModel({
      id: cart._id!,
      purchaseFlowId: cart.purchaseFlowId!,
      lineItems: (cart.lineItems ?? []).map((lineItem) =>
        LineItemModel.fromV2(lineItem, modelContext),
      ),
      deliveryMethodCode: cart.deliveryInfo?.method?.code,
      pricesIncludeTax: cart.taxInfo?.pricesIncludeTax,
      currency: cart.paymentInfo!.currencyCode!,
    });
  }
}
